export function formatToUSPhoneNumber(number) {
	const cleaned = ('' + number).replace(/\D/g, '');
	const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
	if (!match) {
		return 'Invalid format!';
	}
	return `(${match[1]}) ${match[2]}-${match[3]}`;
}
